import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import GlassPopup from '../common/interface/glassPopup';
import File from '../common/inputs/file';
import ErrorFeedback from '../common/feedback/errorFeedback';
import Select from '../common/inputs/select';
import FieldInfo from '../common/inputs/fieldInfo';

const ImportMetricDataFormPopup = props => {
  const {
    handleShowPopup,
    handleDownloadImportSheet,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    errors,
    popupState,
    importFilesList,
    selectedImportFile,
    handleOnChangeImportFile,
    metricGroupSelected
  } = props;
  return (
    <GlassPopup
      className="form_popup import_form_popup"
      title={(<FormattedMessage 
         id="common.entity.importEntitiesWithName"
         values={{entityNamePlural: <FormattedMessage id="metricDataAdmin.entityNamePlural"/>}}
       />)}
      buttonText={(<FormattedMessage 
         id="common.entity.importEntitiesWithName"
         values={{entityNamePlural: <FormattedMessage id="metricDataAdmin.entityNamePlural"/>}}
       />)}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
      />
      <p className="form_paragraph">
        <FormattedMessage 
          id="common.entity.importDownloadLinkDescription"
          values={{entityNamePlural: <FormattedMessage id="metricDataAdmin.entityNamePlural"/>}}
        />
        {": "}
        <a onClick={handleDownloadImportSheet}>
          <FormattedMessage id="common.entity.importLinkDownload"/>
        </a>
      </p>
      <FieldInfo 
        label={(<FormattedMessage id="metricAdmin.importGroupName"/>)}
        value={metricGroupSelected ? metricGroupSelected.name : ""}
        className="first_info_import"
      />
      <FieldInfo 
        label={(<FormattedMessage id="metricAdmin.importMetricNames"/>)}
        value={metricGroupSelected ? metricGroupSelected.metric_names : ""}
      />
      <label className="form_info">
        <FormattedMessage id={"metricAdmin.importDataHelpMessage"}/>
      </label>
      <label className="form_info">
        <strong><FormattedMessage id={"metricAdmin.importDataHelpMessageImportant"}/></strong>
      </label>      
      <label className="form_info">
        <FormattedMessage id={"metricAdmin.importDataHelpMessage2"}/>
      </label>
      <File
        id="import_file"
        accept=".csv"
      />
      <Select 
        value={selectedImportFile}
        onChange={handleOnChangeImportFile}
        labelLocale={<FormattedMessage id="metricDataAdmin.importFilesSelect"/>}
        options={importFilesList ? [""].concat(importFilesList.map(item => { return {value: item, label: item} })) : []}
        className="select_import_files"
      />
      <label className="form_info">
        <FormattedMessage id={"metricAdmin.importDataHelpMessage3"}/>
      </label>
    </GlassPopup>
  );
};

export default ImportMetricDataFormPopup;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/importMetricDataFormPopup.jsx